<script setup lang="ts">
import {onBeforeMount, type PropType, ref} from "vue";
import NamaCommon from "@/utils/common/NamaCommon";
import {useInterval} from "@vueuse/core";
import DTOUserNotification = namaTypes.DTOUserNotification;

let props = defineProps({
  notification: {
    type: Object as PropType<DTOUserNotification>,
    required: true
  }
});

let timeDiff = ref("");

onBeforeMount(() => {
  timeDiff.value = NamaCommon.getDateDifferenceAsString(props.notification.submittedOn!);
})

useInterval(60000, {
  callback(count) {
    timeDiff.value = NamaCommon.getDateDifferenceAsString(props.notification.submittedOn!);
  },
})
</script>

<template>
  <div
      class="tw-group tw-w-full tw-flex tw-flex-col tw-items-center tw-justify-center tw-border-b-[0.25px] tw-border-gray-300 tw-p-2.5
        hover:tw-bg-namaBackground-dim-light dark:hover:tw-bg-namaBackground-dim-dark hover:tw-border-primary-light dark:tw-border-primary-dark">
    <div class="tw-w-full tw-flex tw-items-center tw-pb-2"
         :class="{'tw-justify-between':notification.body,'tw-justify-end':!notification.body}">
      <div class="tw-font-bold dark:tw-text-namaFontColor-dark tw-text-base" v-html="notification.subject" v-if="notification.body"></div>
      <span class="tw-font-normal tw-text-[#343A40] dark:tw-text-gray-200 tw-text-xs" v-text="timeDiff"/>
    </div>
    <div class="tw-w-full tw-max-h-[calc(50vh-var(--navbar-height))]" data-scrollbar-reveal>
      <div class="tempo-tooltip-content"
           v-html="notification.body??notification.subject"></div>
    </div>
  </div>
</template>

<style scoped>

</style>
